<template>
    <div class="relative banner_bg" style="background:#14181e; overflow:hidden; z-index: 0;">
        <div style="position:absolute; top:0; right:0; bottom:0; left:0;">
            <div class="column center v-center" style="position:absolute; top:0; right:0; bottom:0; left:0; z-index:2;">

                    <div
                    v-if="clientWidth >= 992"
                    class="column text-center white px-xl"
                    style="font-weight:bold; font-style: italic; letter-spacing:0.1em; opacity:.88;"
                >

                </div>
                <div   class="column text-center white px-xl "
                    style="font-weight:bold; font-style: italic; letter-spacing:0.1em; opacity:.88;">
                    <div class="h1" style="color:#CA281C">全国首家数字互动礼赠平台</div>
                    <div class="h2 mt-sm">
                        <span class="mr-xl"  style="color:#CA281C">开启掌上互动，共铸永恒瞬间</span>
                    </div>
                </div>
              <!--  <div v-else class="white"
                    style="z-index:2; position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); width:48px; height:48px; text-align:center; line-height:48px; border-radius:50%;">
                    <div class="icon-48" style="width:48px; height:48px;">
                        <i class="iconfont icon-play-2x-o" style="font-size:48px;"></i>
                    </div>
                </div> -->
            </div>

            <div v-if="isWeixin" class="column center v-center" @click="play"
                style="position:absolute; top:0; right:0; bottom:0; left:0; z-index:3; color:transparent;">
                {{ !isPlaying ? 'play' : 'pause' }}
            </div>

            <video width="100%" ref="player" id="video" class="video1 video"  preload   x-webkit-airplay="true"
                airplay="allow" webkit-playsinline="true" playsinline="true" :src="!isWeixin ? IndexVideo : IndexVideo"  autoplay
                :poster="!isWeixin ? Poster : Poster"  :muted ="!isWeixin" :loop="!isWeixin" ></video>
                <!-- v-if="clientWidth >= 992" -->
            <div class="slide_tips1">
				<div

				    class="column text-center white px-xl"
				    style="font-weight:bold; font-style: italic; letter-spacing:0.1em; opacity:.88;"
				>
				<!-- <div class="h4 mt-sm">
				    <span class="mr-xl">开启掌上互动，捕捉永恒瞬间</span>
				</div -->>

				</div>


            </div>
			<div class="slide_tips">

                <i class="s_line"></i>
                <span class="txt">查看更多</span>
            </div>
        </div>
    </div>
</template>

<script>
import {

 IndexVideo, Poster, AppIcon, AppImg,
} from '@/constants/pics';

export default {
    name: 'focus',

    props: [],

    components: {},

    data() {
        return {
            IndexVideo,
            Poster,
            AppIcon,
            AppImg,
            clientWidth: 0,
            isPlaying: false,
            isWeixin: false,
        };
    },

    computed: {
        backgroundImageUrl() {
            return `url(${FocusBanner})`;
        },
    },

    mounted() {
        // 01
        const { clientWidth } = document.documentElement;
        this.clientWidth = clientWidth;
        window.addEventListener(
            'resize',
            () => {
                const { clientWidth } = document.documentElement;
                this.clientWidth = clientWidth;
            },
            false,
        );

        // 02
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.isWeixin = true;
        } else {
            this.isWeixin = false;
        }

        // 03
        if (this.isWeixin) {
            this.$nextTick(function () {
                setTimeout(() => {
                    const { player } = this.$refs;
                    if (player.paused) {
                        this.isPlaying = false;
                    } else {
                        this.isPlaying = true;
                    }
                }, 1000);
            });
        } else {
            this.isPlaying = true;
        }
    },

    methods: {
        play() {
            const { player } = this.$refs;
            if (player.paused) {
                player.play();
                this.isPlaying = true;
            } else {
                player.pause();
                this.isPlaying = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.slide_tips1 {
    display: block;
    width: 100%;

    position: absolute;

    bottom: 100px;
    z-index: 2;
}
// slide_tips
.slide_tips {
    display: block;
    width: 80px;
    height: 57px;
    position: absolute;
    left: 50%;
    margin-left: -40px;
    bottom: 32px;
    z-index: 2;
}

.slide_tips .s_line {
    animation: a_banner_s_line 3s 0.3s linear both infinite;
    -webkit-animation: a_banner_s_line 3s 0.3s linear both infinite;
    -ms-animation: a_banner_s_line 3s 0.3s linear both infinite;
    -moz-animation: a_banner_s_line 3s 0.3s linear both infinite;
    -o-animation: a_banner_s_line 3s 0.3s linear both infinite;
}

.slide_tips .s_line {
    display: block;
    width: 2px;
    height: 32px;
    border-radius: 2px;
    position: absolute;
    left: 50%;
    margin-left: -1px;
    top: 0px;
    background: #fff;
}

.slide_tips .txt {
    display: block;
    width: 100%;
    position: absolute;
    left: 0;
    text-align: center;
    bottom: 0px;
    font-size: 12px;
    letter-spacing: 2px;
    color: #fff;
}

@keyframes a_banner_s_line {
    0% {
        transform: scale(1, 1);
        -webkit-transform: scale(1, 1);
        -ms-transform: scale(1, 1);
        -moz-transform: scale(1, 1);
        -o-transform: scale(1, 1);
        transform-origin: 50% 100%;
        -webkit-transform-origin: 50% 100%;
        -ms-transform-origin: 50% 100%;
        -moz-transform-origin: 50% 100%;
        -o-transform-origin: 50% 100%;
        opacity: 1;
    }

    20% {
        transform: scale(1, 0.01);
        -webkit-transform: scale(1, 0.01);
        -ms-transform: scale(1, 0.01);
        -moz-transform: scale(1, 0.01);
        -o-transform: scale(1, 0.01);
        transform-origin: 50% 100%;
        -webkit-transform-origin: 50% 100%;
        -ms-transform-origin: 50% 100%;
        -moz-transform-origin: 50% 100%;
        -o-transform-origin: 50% 100%;
        opacity: 1;
    }

    30% {
        transform: scale(1, 0.01);
        -webkit-transform: scale(1, 0.01);
        -ms-transform: scale(1, 0.01);
        -moz-transform: scale(1, 0.01);
        -o-transform: scale(1, 0.01);
        transform-origin: 50% 100%;
        -webkit-transform-origin: 50% 100%;
        -ms-transform-origin: 50% 100%;
        -moz-transform-origin: 50% 100%;
        -o-transform-origin: 50% 100%;
        opacity: 0;
    }

    31% {
        transform: scale(1, 0.01);
        -webkit-transform: scale(1, 0.01);
        -ms-transform: scale(1, 0.01);
        -moz-transform: scale(1, 0.01);
        -o-transform: scale(1, 0.01);
        transform-origin: 50% 0;
        -webkit-transform-origin: 50% 0;
        -ms-transform-origin: 50% 0;
        -moz-transform-origin: 50% 0;
        -o-transform-origin: 50% 0;
        opacity: 0;
    }

    50% {
        transform: scale(1, 1);
        -webkit-transform: scale(1, 1);
        -ms-transform: scale(1, 1);
        -moz-transform: scale(1, 1);
        -o-transform: scale(1, 1);
        transform-origin: 50% 0;
        -webkit-transform-origin: 50% 0;
        -ms-transform-origin: 50% 0;
        -moz-transform-origin: 50% 0;
        -o-transform-origin: 50% 0;
        opacity: 1;
    }

    100% {
        transform: scale(1, 1);
        -webkit-transform: scale(1, 1);
        -ms-transform: scale(1, 1);
        -moz-transform: scale(1, 1);
        -o-transform: scale(1, 1);
        transform-origin: 50% 100%;
        -webkit-transform-origin: 50% 100%;
        -ms-transform-origin: 50% 100%;
        -moz-transform-origin: 50% 100%;
        -o-transform-origin: 50% 100%;
        opacity: 1;
    }
}

@media screen and (min-width: 1921px) {
    .banner_bg {
        height: 1040px;
    }

    .video1 {
        position: absolute;
        height: auto;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@media (min-width: 992px) and (max-width: 1920px) {
    .banner_bg {
        height: 780px;
        background: #1b1f25;
    }

    .video1 {
        width: 2560px;
        height: 930px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 1;
    }
}

@media (max-width: 991px) {
    .banner_bg {
        height: 560px;
        background: #1b1f25;
    }

    .video1 {
        width: 1504px;
        height: 560px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 1;
    }

    .slide_tips {
        bottom: 24px;
    }
}
</style>
